document.documentElement.classList.remove('no-js');

const qs=(s,c=document)=>c.querySelector(s);const qsa=(s,c=document)=>[...c.querySelectorAll(s)];

function togglePanel(button,panel){const open=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!open));panel.hidden=open;}

document.addEventListener('click',e=>{
  const menu=e.target.closest('[data-menu-toggle]');if(menu){const panel=qs('[data-mobile-nav]');if(panel)togglePanel(menu,panel);}
  const search=e.target.closest('[data-search-toggle]');if(search){const panel=qs('[data-search-panel]');if(panel){togglePanel(search,panel);if(!panel.hidden)setTimeout(()=>qs('input[type="search"]',panel)?.focus(),50);}}
  if(e.target.closest('[data-filter-toggle]'))qs('[data-filters]')?.classList.toggle('is-open');
});

const predictiveInput=qs('[data-predictive-search-input]');const predictiveResults=qs('[data-predictive-results]');const predictiveForm=qs('[data-predictive-search-form]');let searchTimer;
if(predictiveInput&&predictiveResults){predictiveInput.addEventListener('input',()=>{clearTimeout(searchTimer);const term=predictiveInput.value.trim();if(term.length<2){predictiveResults.innerHTML='';return;}searchTimer=setTimeout(async()=>{try{const base=predictiveForm?.dataset.predictiveUrl||`${window.Shopify.routes.root}search/suggest`;const url=`${base}?q=${encodeURIComponent(term)}&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search`;const r=await fetch(url);const html=await r.text();const doc=new DOMParser().parseFromString(html,'text/html');predictiveResults.innerHTML=doc.querySelector('#shopify-section-predictive-search')?.innerHTML||'';}catch(err){console.warn('Predictive search unavailable',err);}},180);});}

qsa('[data-gallery-thumb]').forEach(btn=>btn.addEventListener('click',()=>{const gallery=btn.closest('[data-gallery]');qsa('[data-gallery-thumb]',gallery).forEach(x=>x.classList.remove('is-active'));btn.classList.add('is-active');qsa('[data-media-id]',gallery).forEach(x=>x.classList.toggle('is-hidden',x.dataset.mediaId!==btn.dataset.galleryThumb));}));

qsa('[data-qty-minus],[data-qty-plus]').forEach(btn=>btn.addEventListener('click',()=>{const control=btn.closest('.quantity-control');const input=qs('input',control);if(!input)return;const delta=btn.matches('[data-qty-minus]')?-1:1;const min=Number(input.min||0);input.value=Math.max(min,Number(input.value||0)+delta);input.dispatchEvent(new Event('change',{bubbles:true}));}));

// Variant switching uses native Shopify variant URLs for reliable server-rendered pricing.

qsa('form.quick-add').forEach(form=>form.addEventListener('submit',async e=>{e.preventDefault();const btn=qs('button',form);if(btn)btn.disabled=true;try{const fd=new FormData(form);const r=await fetch(`${window.Shopify.routes.root}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body:fd});if(!r.ok)throw new Error('Cart add failed');const cart=await fetch(`${window.Shopify.routes.root}cart.js`).then(x=>x.json());qsa('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);if(btn){btn.textContent='Added';setTimeout(()=>btn.textContent='Quick add',1200);}}catch(err){if(btn)btn.textContent='Try again';}finally{if(btn)btn.disabled=false;}}));

const rec=qs('[data-product-recommendations]');if(rec&&rec.dataset.url){fetch(rec.dataset.url).then(r=>r.text()).then(text=>{const html=new DOMParser().parseFromString(text,'text/html');const incoming=html.querySelector('[data-product-recommendations]');if(incoming&&incoming.innerHTML.trim())rec.innerHTML=incoming.innerHTML;}).catch(()=>{});}


// Apex cart controls
const cartPage=qs('[data-cart-page]');
if(cartPage){
  const cartRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';

  const setBusy=(busy)=>{
    cartPage.classList.toggle('is-cart-busy',busy);
    qsa('button,input',cartPage).forEach(el=>{
      if(el.matches('[name="checkout"]')) return;
      el.disabled=busy;
    });
  };

  const updateCartCount=(count)=>{
    qsa('[data-cart-count]').forEach(el=>el.textContent=count);
  };

  const changeLine=async(line,quantity)=>{
    setBusy(true);
    try{
      const initialCart=await fetch(`${cartRoot}cart.js`).then(r=>r.json());
      const originalItem=initialCart.items[Number(line)-1];
      const response=await fetch(`${cartRoot}cart/change.js`,{
        method:'POST',
        headers:{
          'Content-Type':'application/json',
          'Accept':'application/json'
        },
        body:JSON.stringify({line:Number(line),quantity:Number(quantity)})
      });
      if(!response.ok) throw new Error('Unable to update cart');
      let cart=await response.json();
      // If the original styling item is removed or quantity changes, adjust its linked service.
      const ref=originalItem?.properties?._apex_fitting_ref;
      if(ref&&originalItem?.properties?._apex_fitting_role==='product'){
        const paidLine=cart.items.find(i=>i.properties?._apex_fitting_ref===ref && i.properties?._apex_fitting_role==='service');
        if(paidLine && paidLine.quantity!==Number(quantity)){
          const fittingUpdate=await fetch(`${cartRoot}cart/change.js`,{
            method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({id:paidLine.key,quantity:Number(quantity)})
          });
          if(!fittingUpdate.ok)throw new Error('Could not synchronise the installation charge');
          cart=await fittingUpdate.json();
        }
      }
      updateCartCount(cart.item_count);
      window.location.reload();
    }catch(error){
      console.error(error);
      setBusy(false);
      window.alert('We could not update your cart. Please try again.');
    }
  };

  qsa('[data-cart-qty-minus]',cartPage).forEach(btn=>{
    btn.addEventListener('click',()=>{
      const line=btn.dataset.line;
      const input=qs(`[data-cart-qty-input][data-line="${line}"]`,cartPage);
      if(!input)return;
      const current=Math.max(0,Number(input.value||0));

      // If there is only one left, minus removes the item completely.
      if(current<=1){
        changeLine(line,0);
        return;
      }

      changeLine(line,current-1);
    });
  });

  qsa('[data-cart-qty-plus]',cartPage).forEach(btn=>{
    btn.addEventListener('click',()=>{
      const line=btn.dataset.line;
      const input=qs(`[data-cart-qty-input][data-line="${line}"]`,cartPage);
      if(!input)return;
      const current=Math.max(0,Number(input.value||0));
      changeLine(line,current+1);
    });
  });

  qsa('[data-cart-qty-input]',cartPage).forEach(input=>{
    input.addEventListener('change',()=>{
      const line=input.dataset.line;
      const quantity=Math.max(0,Number(input.value||0));
      changeLine(line,quantity);
    });
  });

  qsa('[data-cart-remove]',cartPage).forEach(btn=>{
    btn.addEventListener('click',()=>changeLine(btn.dataset.line,0));
  });

  const itemChecks=()=>qsa('[data-cart-item-select]',cartPage);
  const selectedCount=qs('[data-cart-selected-count]',cartPage);

  const refreshSelection=()=>{
    const checks=itemChecks();
    let count=0;
    checks.forEach(check=>{
      const row=check.closest('[data-cart-item]');
      const selected=check.checked;
      if(selected)count++;
      if(row)row.classList.toggle('is-selected',selected);
    });
    if(selectedCount)selectedCount.textContent=count;
  };

  itemChecks().forEach(check=>check.addEventListener('change',refreshSelection));

  const selectAll=qs('[data-cart-select-all]',cartPage);
  if(selectAll){
    selectAll.addEventListener('click',()=>{
      itemChecks().forEach(check=>check.checked=true);
      refreshSelection();
    });
  }

  const deselectAll=qs('[data-cart-deselect-all]',cartPage);
  if(deselectAll){
    deselectAll.addEventListener('click',()=>{
      itemChecks().forEach(check=>check.checked=false);
      refreshSelection();
    });
  }

  const emptyCart=qs('[data-cart-empty]',cartPage);
  if(emptyCart){
    emptyCart.addEventListener('click',async()=>{
      if(!window.confirm('Remove all items from your cart?'))return;
      setBusy(true);
      try{
        const response=await fetch(`${cartRoot}cart/clear.js`,{
          method:'POST',
          headers:{'Accept':'application/json'}
        });
        if(!response.ok)throw new Error('Unable to clear cart');
        const cart=await response.json();
        updateCartCount(cart.item_count);
        window.location.reload();
      }catch(error){
        console.error(error);
        setBusy(false);
        window.alert('We could not empty your cart. Please try again.');
      }
    });
  }

  refreshSelection();
}


// Apex v4.2: Shopify Markets currency selector
qsa('[data-apex-country-selector]').forEach(select=>{
  select.addEventListener('change',()=>{
    const form=select.closest('form');
    if(form) form.submit();
  });
});

// Paid Auckland fitting add-on. The matching Shopify service product is required.
qsa('[data-product-root] .product-form').forEach(form=>{
  const addon=qs('[data-apex-install-addon]',form);
  if(!addon)return;
  const toggle=qs('[data-apex-install-toggle]',addon);
  const vehicleLabel=qs('[data-apex-install-vehicle]',addon);
  const carInput=qs('[data-apex-install-car]',addon);
  const consentLabel=qs('[data-apex-drilling-consent]',addon);
  const consent=qs('[data-apex-drilling-agree]',addon);
  const feedback=qs('[data-apex-install-error]',addon);
  const addButton=qs('[data-add-to-cart]',form);
  toggle?.addEventListener('change',()=>{
    const active=toggle.checked;
    if(vehicleLabel)vehicleLabel.hidden=!active;
    if(consentLabel)consentLabel.hidden=!active;
    if(carInput)carInput.required=active;
    if(consent)consent.required=active;
    if(feedback)feedback.textContent='';
  });
  form.addEventListener('submit',async(event)=>{
    if(!toggle?.checked)return; // Standard form submission, without paid fitting.
    event.preventDefault();
    if(!form.reportValidity())return;
    const id=Number(qs('[data-variant-id]',form)?.value);
    const fittingId=Number(addon.dataset.installVariant);
    const quantity=Number(qs('input[name="quantity"]',form)?.value||1);
    if(!Number.isSafeInteger(id)||!Number.isSafeInteger(fittingId)||!Number.isInteger(quantity)||quantity<1||quantity>100){
      if(feedback)feedback.textContent='Unable to add fitting. Please contact us.';return;
    }
    const ref='apex-'+Date.now()+'-'+Math.random().toString(36).slice(2,9);
    const productProps={_apex_fitting_ref:ref,_apex_fitting_role:'product'};
    const fittingProps={_apex_fitting_ref:ref,_apex_fitting_role:'service',
      'Vehicle':carInput?.value.trim()||'', 'Fitting location':'Auckland workshop by appointment',
      'Fits product variant':String(id)};
    if(addon.dataset.fittingKind==='Splitter')fittingProps['Drilling discussion required']='Yes – customer to confirm at fitting';
    if(addButton){addButton.disabled=true;addButton.textContent='Adding fitting…';}
    if(feedback)feedback.textContent='';
    try{
      const root=window.Shopify?.routes?.root||'/';
      const response=await fetch(`${root}cart/add.js`,{
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id,quantity,properties:productProps},{id:fittingId,quantity,properties:fittingProps}]})
      });
      if(!response.ok){const data=await response.json().catch(()=>({}));throw new Error(data.description||data.message||'Unable to add installation');}
      window.location.href=`${root}cart`;
    }catch(error){
      if(feedback)feedback.textContent=error.message||'Unable to add installation. Please try again.';
      if(addButton){addButton.disabled=false;addButton.textContent='Add to Cart';}
    }
  });
});
